import type { ReactNode } from "react";

/** Standard page header (U5): eyebrow · h1 · optional description · optional
 *  right-side slot. Every page uses THIS — the pagehead/eyebrow/h1 block was
 *  hand-written 16 times before extraction. */
export function PageHead({ eyebrow, title, desc, right }: {
  eyebrow: string; title: string; desc?: ReactNode; right?: ReactNode;
}) {
  return (
    <div className="pagehead">
      <div className="grow">
        <div className="eyebrow">{eyebrow}</div>
        <h1>{title}</h1>
        {desc && (
          <p className="cap" style={{ margin: "6px 0 0", maxWidth: "70ch" }}>
            {desc}
          </p>
        )}
      </div>
      {right}
    </div>
  );
}
